<template>
	<div class='route_container'>				
		<!-- Hero section -->
		<div class="bg-gradient py-5 px-5 mt-4 hero_section">
			<div v-if="user.username && $store.state.username && (user.username.toLowerCase() == $store.state.username.toLowerCase())">
				<v-container grid-list-xl>					
					<avatar v-model="profile">
						<div slot="activator">
							<div>
								<v-avatar size="200px" v-ripple class="mb-3">
									<img v-if="profile" :src="profile.imageURL" 
										alt="avatar" height="200px">									
									<font-awesome-icon v-else-if="!profile && !user.profile_photo_path"  :icon="['fa','user']" style="font-size: 145pt;" class="d-flex m-auto"/>
									<img v-else :src="`${domain}/uploads/avatar/${user.profile_photo_path}`" 
										alt="avatar" height="200px">
								</v-avatar>
								<v-avatar v-if="!profile" width="200px" v-ripple class="grey lighten-3 mb-0">
									<button class="btn btn-secondary btn-xs justify-content-center align-items-center d-flex m-auto">
										<small style="font-size: 12pt">{{ $t('gifts_change_image') }}</small>
									</button>
								</v-avatar>
							</div>
						</div>
					</avatar>
					<v-slide-x-transition>
						<div v-if="profile && saved == false">							
							<button class="btn btn-secondary btn-xs justify-content-center align-items-center d-flex m-auto"
									@click="uploadImage" :loading="saving">
								<small style="font-size: 12pt">{{ $t('gifts_save_image') }}</small>
							</button>
						</div>
					</v-slide-x-transition>
				</v-container>
			</div>
			<div v-else class="mr-3">
				<img v-if="user.profile_photo_path" :src="`${domain}/uploads/avatar/${user.profile_photo_path}`" height="200px">
				<font-awesome-icon v-else :icon="['fa','user']" style="font-size: 145pt;"  class="d-flex m-auto"/>
			</div>
			<div class="hero_section__summary py-3 px-3">
				<div class='col-12' key='loading' v-if="loading">
					<thread-display-placeholder></thread-display-placeholder>
				</div>
				<div class="col-12" v-else>
					<h2 class="mb-2">{{user.username}}</h2>
					<div class="featured__table">
						<div class="featured__table__column">
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_role') }}</div>
								<div class="featured__table__row__right">
									<span v-if="user.admin.toLowerCase() === 'member'" style="color: #00ff7f;" class="font-weight-bold">{{ $t('gifts_member') }}</span>
									<span v-if="user.admin.toLowerCase() === 'admin'" style="color: #00ff7f;" class="font-weight-bold">{{ $t('gifts_admin') }}</span>									
								</div>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_last_online') }}</div>
								<info-tooltip v-if="!online">
									<template slot='content'>
										<span>
											<font-awesome-icon class="info_icon" :icon="['fa','clock']" />
											{{ $t('gifts_last_online') }}: {{user.last_seen | localTime}}
										</span>
									</template>
									<div slot='display'>
										{{user.last_seen | localTime | formatDate}} {{ $t('gifts_ago') }}
									</div>
								</info-tooltip>

								<info-tooltip v-else>
									<template slot='content'>
										<span>
											<font-awesome-icon class="info_icon" :icon="['fa','clock']" />
											{{ $t('gifts_just_now') }}: {{user.last_seen | localTime}}
										</span>
									</template>
									<div
										slot='display'
										style="color: #00ff7f;" class="font-weight-bold"
									>
										{{ $t('gifts_online') }}
									</div>
								</info-tooltip>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_registered') }}</div>
								<info-tooltip>
									<template slot='content'>
										<p><font-awesome-icon class="info_icon" :icon="['fa','clock']" />{{ $t('gifts_registered') }}: {{user.created_at}}</p>
									</template>
									<div
										slot='display'
									>
										{{user.created_at | localTime | formatDate}} {{ $t('gifts_ago') }}
									</div>
								</info-tooltip>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_comments') }}</div>
								<div class="featured__table__row__right">{{user.comment_cnt}}</div>
							</div>
						</div>
						<div class="featured__table__column">
							<div class="row">
								<div class="featured__table__row__left">Giveaways {{ $t('gifts_entered') }}</div>
								<div class="featured__table__row__right">{{user.gw_entered_cnt}}</div>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_gifts_won') }}</div>
								<info-tooltip>
									<template slot='content'>
										<div class="info_row">
											<p>
												<font-awesome-icon  class="info_icon"  :icon="['fa','check-circle']" />
												{{ $t('gifts_received') }}
											</p> 
											<p>{{user.gw_win_cnt}}</p>
										</div>
										<div class="info_row">
											<p class="ml-4">{{ $t('gifts_full_value') }}</p> <p>{{ user.gw_full_value_cnt }}</p>
										</div>
										<div class="info_row"><p class="ml-4">{{ $t('gifts_reduced_value') }}</p> <p>{{ user.gw_reduced_value_cnt }}</p></div>
										<div class="info_row"><p class="ml-4">{{ $t('gifts_no_value') }}</p> <p>{{ user.gw_no_value_cnt }}</p></div>
									</template>
									<div slot='display' class="mr-4">
										<span style="color: #00ff7f;">{{user.gw_win_cnt}}</span>
									</div>
								</info-tooltip>
								<info-tooltip>
									<template slot='content'>
										<div class="info_row">
											<p><font-awesome-icon  class="info_icon"  :icon="['fas','dollar-sign']" />{{ $t('gifts_received') }}</p> 
											<p>{{user.gw_value}}</p>
										</div>
									</template>
									<div slot='display'>
										<span> ($ {{ user.gw_total_value }}) </span> 
									</div>
								</info-tooltip>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_gifts') }} {{ $t('gifts_sent') }}</div>
								<info-tooltip>
									<template slot='content'>
										<div class="info_row">
											<p><font-awesome-icon  class="info_icon"  :icon="['fa','check-circle']" />{{ $t('gifts_received') }}</p> 
											<p>{{user.cb_sent_cnt}}</p>
										</div>
										<div class="info_row"><p class="ml-4">{{ $t('gifts_full_value') }}</p> <p>{{ user.cb_full_value_cnt }}</p></div>
										<div class="info_row"><p class="ml-4">{{ $t('gifts_reduced_value') }}</p> <p>{{ user.cb_reduced_value_cnt }}</p></div>
										<div class="info_row"><p class="ml-4">{{ $t('gifts_no_value') }}</p> <p>{{ user.cb_no_value_cnt }}</p></div>
									</template>
									<div slot='display' class="mr-4">
										<span style="color: #00ff7f;">{{user.cb_sent_cnt}}</span>
									</div>
								</info-tooltip>
								<info-tooltip>
									<template slot='content'>
										<div class="info_row">
											<p><font-awesome-icon  class="info_icon"  :icon="['fas','dollar-sign']" />{{ $t('gifts_received') }}</p> 
											<p>{{ user.cb_value }}</p>
										</div>
									</template>
									<div slot='display'>
										<span>($ {{ user.cb_total_value }})</span>
									</div>
								</info-tooltip>
							</div>
							<div class="row">
								<div class="featured__table__row__left">{{ $t('gifts_contributor_level') }}</div>
								<info-tooltip>
									<template slot='content'>
										<div class="info_row">
											<p><font-awesome-icon  class="info_icon mr-3"  :icon="['fa','gift']" />{{ $t('gifts_contributor_level') }} : </p> 
											<p>{{user.cb_level}}</p>
										</div>
									</template>
									<div slot='display'>
										<span v-for="(k, i) in 10" :key="i">											
											<font-awesome-icon v-if="k <= user.cb_level"  class="info_icon mr-1"  :icon="['fas','circle']" />
											<font-awesome-icon v-else  class="info_icon mr-1"  :icon="['fas','circle-notch']" />
										</span>
									</div>
								</info-tooltip>
							</div>
						</div>
					</div>
				</div>
								
			</div>
		</div>
		<div class="main_container px-5 py-3">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0 py-3">
					<div class="row w-auto pb-3"
						v-if="user.username && $store.state.username && (user.username.toLowerCase() != $store.state.username.toLowerCase())"
						>
						<!-- whitelist vote -->
						<div class="col-3 p-0" v-if="whiteUserVoting">
							<loading-button							
								:loading='whiteUserVoting'
								class='nav-link votes pl-0'
							>
								<font-awesome-icon icon="spinner"/>
							</loading-button>
						</div>
						<div class="col-3 p-0" v-if="!whiteUserVoting">
							<button class="btn btn-primary btn-md rounded votes" 
									:class="{'btn-secondary' : whiteClicked}"
									@click="userVotes('whitelist')"	
									:title="$t('gifts_add_to_whitelist')"
									>
								<font-awesome-icon :icon='["fa", "heart"]' />&nbsp;						
							</button>
						</div>

						<!-- blacklist vote -->
						<div class="col-3 p-0" v-if="blackUserVoting">
							<loading-button							
								:loading='blackUserVoting'
								class='nav-link votes pl-0'
							>
								<font-awesome-icon icon="spinner"/>
							</loading-button>
						</div>
						<div class="col-3 p-0" v-if="!blackUserVoting">							
							<button class="btn btn-primary btn-md rounded votes"
									:class="{'btn-secondary' : blackClicked}"
									@click="userVotes('blacklist')"
									:title="$t('gifts_add_to_blacklist')"
									>
								<font-awesome-icon :icon='["fa", "ban"]' />&nbsp;						
							</button>
						</div>


						<div class="col-3 p-0">							
							<button	class="btn btn-primary btn-md rounded votes"
									@click="getSupport()"
									:title="$t('gifts_report_user')"
									>
								<font-awesome-icon :icon='["fa", "exclamation"]' />&nbsp;						
							</button>
							
						</div>
						<div class="col-3 p-0">							
							<a 	class="btn btn-primary btn-md rounded idc-brand votes" 
								:title="`IDC ${ $t('gifts_profile') }`"
								:href="`https://${$store.state.meta.lang}.idcgames.com/info/my-account`" target="_blank"></a>
						</div>										
						
					</div>
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchGiveaway'
						type="text"
						aria-label="Search"
						ref="search"
						:error='errors.search'
						:large='true'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">{{ $t('gifts_activity') }}</p>
								</div>
							</div>
							<!--  -->
							<router-link class='threads_main__side_bar__menu_item' 
										:to="`/${$store.state.meta.lang}/giveaway/created`">
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>Giveaways</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>{{ user.gw_created_cnt || 0 }}</span>
							</router-link>
							<router-link class='threads_main__side_bar__menu_item' 
										:to="`/${$store.state.meta.lang}/discussion/created`">
								<p class="d-flex">
									<span class='threads_main__side_bar__menu_item__border'></span>
									<span class='threads_main__side_bar__menu_item__text'>{{ $t('gifts_discussions') }}</span>
								</p>
								<span class='threads_main__side_bar__menu_item__text'>{{ user.ds_created_cnt || 0 }}</span>
							</router-link>
							<!--  -->
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3" v-if="loading">
					<thread-display-placeholder></thread-display-placeholder>					
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3" v-else>
					<h2 class="border-bottom border-green-lighter my-3"> {{ $route.params.username }} </h2>
					<!-- giveway list -->
					<div class="bg-gray-900 border border-green-lighter mt-3 px-3">						
						<div class="giveaway__row-outer-wrap" v-for="giveaway in drawGiveaways" :key="giveaway.id">
							<div class="giveaway__row-inner-wrap">
								<div class="giveaway__summary">
									<div class="giveaway__heading">										
										<!-- giveaway linke >> -->
										<router-link v-if="!giveaway.region.show" 
											class="giveaway__heading__name" to="">{{giveaway.game_name}}
										</router-link>
										<router-link v-else	class="giveaway__heading__name" :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											{{giveaway.game_name}}
										</router-link>
										<!-- << giveaway linke -->
										<span class="giveaway__heading__thin">({{ giveaway && giveaway.point}})</span>
										<a 	class="giveaway__icon" target="_blank" 
											:href="`https://${$store.state.meta.lang}.idcgames.com/${giveaway.game_seo}`">
											<font-awesome-icon :icon="['fab','steam']" />
										</a>
										<router-link class="giveaway__icon" to="">
											<font-awesome-icon :icon="['fa','camera']" /></router-link>										
										<router-link class="giveaway__icon" 
											:to="`/${$store.state.meta.lang}/giveaways/search?app=710600`">
											<font-awesome-icon :icon="['fa','search']" />
										</router-link>
									</div>
									<div class="giveaway__columns">
										<div class="d-flex justify-content-center align-items-center">
											<font-awesome-icon :icon="['fa','clock']" class="mr-1"/>
											<span v-if="giveaway.status=='sent'">
											{{ $t('gifts_ended') }}	<span>{{ giveaway && giveaway.end_date | localTime | formatDate}}</span> {{ $t('gifts_ago') }}
											</span>
											<span v-else>
												<span>{{ giveaway && giveaway.end_date | localTime | formatDate}}</span> {{ $t('gifts_remaining') }}
											</span> 
										</div>
										<div v-if="giveaway.status=='sent' && giveaway.winner" class="d-flex justify-content-center align-items-center">
											<router-link class="giveaway__username" 
												:to="`/${$store.state.meta.lang}/user/${giveaway.winner}`">
												<font-awesome-icon :icon="['fa','check-circle']" class="mr-1"/>
												{{ giveaway.winner }}
											</router-link>
										</div>
										<div v-if="giveaway.status=='sent' && !giveaway.winner" class="d-flex justify-content-center align-items-center">
											No Entries											
										</div>
										<div class="giveaway__columns__width-fill text-right">
											<span>{{ giveaway && giveaway.start_date | localTime | formatDate}}</span> {{ $t('gifts_ago') }} {{ $t('gifts_by') }} 
											<router-link class="giveaway__username" 
												:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`">
												{{giveaway.creator}}
											</router-link>
										</div>
										<!-- Region >> -->																				
										<div v-if="!giveaway.region.show" class="giveaway__columns__region">
											<font-awesome-icon :icon="['fa','globe']" class="d-block text-dark" 
												style="height: 26px; cursor: pointer;" title="Region Restricted"/> 
										</div>
										<!-- Whitelist >> -->
										<div v-if="giveaway.whocanenter.select === 'wgroup'" class="giveaway__columns__region">
											<font-awesome-icon :icon="['fa','heart']" class="d-block text-dark" 
												style="height: 26px; cursor: pointer;" :title="$t('gifts_whitelist')"/> 
										</div>
										<div v-if="giveaway.contribute_level*1" class="giveaway__columns__contributor-level"> {{ $t('gifts_level') }} {{ giveaway.contribute_level }} + </div>
									</div>
									<div class="giveaway__links">										
										<!-- >> entries -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaways/entries/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t("gifts_entries") }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t("gifts_entries") }}
										</router-link>
										<!-- >> comments -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
									</div>
								</div>
								<router-link 
									:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`" 
									class="giveaway_image_avatar"
									:style="giveaway.profile_photo_path ? 
											{ 'background-image': 'url(' + domain + '/uploads/avatar/' + giveaway.profile_photo_path + ')' }:
											{ 'background-image': 'url(' + missed_avatar + ')' }"
								>
								</router-link>
								
								<div class="d-flex flex-row flex-wrap mx-0">
									<div class="game-card-rectangular" >
										<router-link :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`" class="giveaway_image_thumbnail">
											<div class="d-flex flex-row">
												<div class="d-flex align-items-center justify-content-center position-relative">
													<div class="position-relative">
														<div class="overlay">
															<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="giveaway.game_logo"  alt="--">
														</div>
														<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
															<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
														</div>
													</div>
												</div>												
											</div>  													
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- discussions -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import InfoTooltip from '../InfoTooltip.vue'
	import {apiDomain} from '../../config'
	import ThreadDisplayPlaceholder from '../ThreadDisplayPlaceholder';
	import Avatar from '../Avatar';
	import LoadingButton from '../LoadingButton';
	
	export default {
		name: 'user',
		components: {
			FancyInput,
			InfoTooltip,
			ThreadDisplayPlaceholder,
			Avatar,
			LoadingButton,
		},
		data () {
			return {
				domain: apiDomain,
				hero_img: require("./../../assets/img/new-home/header.jpg"),
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				loading: true,
				user: { },
				categories: [],
				searchGiveaway: "",
				errors: {
					content: '',
					name: '',
					pollQuestion: '',
					pollAnswer: '',
					search: ''
				},
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				giveaways: [ ],
				drawGiveaways: [ ],

				profile: null,
      			saving: false,
      			saved: false,
				online: false,
				whiteClicked: false,
				blackClicked: false,
				whiteUserVoting: false,
				blackUserVoting: false,
			}
		},
		methods:{
			getMineGiveaways: function(){				
				this.axios.request({
					method: 'GET',
					url: `${apiDomain}/api/v1/user-giveaway/${this.$route.params.username}`
				}).then(res => {
					this.giveaways = res.data.filter( x => x.creator == this.$route.params.username);
					this.drawGiveaways = this.giveaways;

				}).catch(err => {
					console.log(err);
					this.$router.push('/');
				})
			},
			initInvoke: function(){

				this.loading = true;
				
				if(this.$store.state.username == this.$route.params.username){

					this.axios.post(`${apiDomain}/api/v1/authprofile`, {},
					{ 
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}` } 
					})
					.then(res => {
						if(res.data.success){

							this.user = res.data.data;
							//
							let lTime = this.$options.filters.localTime(this.user.last_seen);
							if(this.$options.filters.differTimeMinute(lTime).nums <= 10){
								this.online = true;
							}else{
								this.online = false;
							}						

							this.loading = false;
						}else{
							this.$router.push('/');	
						}
						
					}).catch(err => {
						console.log(err)
						this.$router.push('/');
					})

				}else{
					
					let xx = this;
					this.axios.get(`${apiDomain}/api/v1/user/${this.$route.params.username}`)
					.then(res => {
						if(res.data.success){

							this.user = res.data.data;
							//
							let lTime = this.$options.filters.localTime(this.user.last_seen);
							if(this.$options.filters.differTimeMinute(lTime).nums <= 10){
								this.online = true;
							}else{
								this.online = false;
							}
							xx.whiteClicked = !!res.data.data.users_votes.filter( x => x.receiver_id == xx.user.id && 
																					   x.sender_id == this.$store.state.user_id &&
																				  	   x.type === 'whitelist' ).length;

							xx.blackClicked = !!res.data.data.users_votes.filter( x => x.receiver_id == xx.user.id && 
																					   x.sender_id == this.$store.state.user_id &&
																				  	   x.type === 'blacklist' ).length;

							this.loading = false;
						}else{
							this.$router.push('/');	
						}
						
					}).catch(err => {
						console.log(err)
						this.$router.push('/');
					})
				}				
			},
			uploadImage() {
				this.saving = true
				setTimeout(() => this.savedAvatar(), 1000)
			},
			savedAvatar() {
				this.saving = false;
				this.saved = true;

				let config = {
						header : {
							'Authorization': `Bearer ${this.$cookies.get('authtoken')}`,
							'Content-Type' : 'multipart/form-data'
						}
					}

				this.profile.formData.append('userid', this.$store.state.user_id);

				this.axios.post(`${apiDomain}/api/v1/avatar/upload`, this.profile.formData, config).
				then(res => {
					if(res.data.success){
						this.user = res.data.data;
						this.loading = false;
					}else{
						this.$router.push('/');	
					}
					
				}).catch(err => {
					console.log(err)
					this.$router.push('/');
				})
			},
			getSupport(){
				window.open('https://support.idcgames.com', '_blank');
			},
			userVotes(type){

				type == 'whitelist' ? (this.whiteUserVoting = true) : ( this.blackUserVoting = true )  ;
				let xx = this;

				this.axios.post(`${apiDomain}/api/v1/usersvotes`, {
					receiver_id: this.user.id,
					type: `${type}`
				},
				{ 
					headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}` } 
				})
				.then(res => {
					if(res.data.success){
						
						this.user = res.data.data;
						//
						let lTime = this.$options.filters.localTime(this.user.last_seen);
						if(this.$options.filters.differTimeMinute(lTime).nums <= 10){
							this.online = true;
						}else{
							this.online = false;
						}											

						xx.whiteClicked = !!res.data.data.users_votes.filter( x => x.receiver_id == xx.user.id && 
																					   x.sender_id == this.$store.state.user_id &&
																				  	   x.type === 'whitelist' ).length;

						xx.blackClicked = !!res.data.data.users_votes.filter( x => x.receiver_id == xx.user.id && 
																					x.sender_id == this.$store.state.user_id &&
																					x.type === 'blacklist' ).length;


						this.loading = false;
						xx.whiteUserVoting = false;
						xx.blackUserVoting = false;
					}else{
						this.$router.push('/');	
					}
					
				}).catch(err => {
					console.log(err)
					this.$router.push('/');
				})			
			}		
			
		},
		mounted: function(){			
			this.initInvoke();
			this.getMineGiveaways();
		},
		watch: {
			searchGiveaway: function(sKey){
				if(!!sKey){
					this.drawGiveaways = this.giveaways.filter( x => x.creator.toLowerCase().includes(sKey.toLowerCase()) );
				}else{
					this.drawGiveaways = this.giveaways;
				}

				!this.drawGiveaways.length ? (this.errors.search = this.$t("gifts_no_results")) : this.errors.search = '';
				!sKey && (this.errors.search = '');
			},
			avatar: {
				handler: function() {
					this.saved = false
				},
				deep: true
			},
			"$route.params.username": function(e){
				this.initInvoke();
				this.getMineGiveaways();
			}
		},		
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.hero_section{
		display: flex;
		justify-content: center; 
		align-items: center;

		@at-root #{&}__img_link {
			margin-right: 25px;
			background-color: rgba(0,0,0,0.2);
			border-left-color: transparent;
			border-top-color: transparent;
			box-shadow: 3px 3px 4px #0000002e;
			padding: 10px;

			img{
				max-width: 500px;
				max-height: 215px;
			}
		}

		.featured__table{
			display: flex;
		}

		@at-root #{&}__summary {
			flex: 1;

			.featured__table__column{
				.row{
					align-items: center;
					justify-content: space-between;
					padding: 7px 0;
					border-bottom: 1px solid rgba(255,255,255,0.3);

					.featured__table__row__left{
						text-align: left;
					}
				}

				&:not(:first-child) {
					margin-left: 25px;
				}	
			}
		}
	}

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.giveaway__row-outer-wrap {
		padding: 15px 0;

		&:not(:last-child){
			border-bottom: 1px solid #d2d6e0;
		}

		.giveaway__row-inner-wrap{
			display: flex;
			align-items: center;

			.giveaway__summary{
				flex: 1;
				margin-right: 1rem;

				.giveaway__heading{
					display: flex;
					align-items: center;
					height: 25px;
					white-space: nowrap;

					&__name{
						font-size: 20px;
					}

					&__thin{
						margin-left: 5px;
						letter-spacing: 1px;
						font-weight: 300;
						font-size: 20px;
					}

					.giveaway__icon{
						margin-left: 0.5rem;
						opacity: .35;
						cursor: pointer;
					}
				}

				.giveaway__columns{
					display: flex;
					align-items: center;
					margin: 0.5rem 0;

					&__width-fill{
						flex: 1;
					}

					&__contributor-level{
						border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
    					color: rgba(166,93,92,0.95) !important;
						background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
					}

					&__region{
						border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
    					color: rgba(194, 190, 190, 0.95) !important;
						background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
					}

					&>*{
						white-space: nowrap;
						border-radius: 4px;
						font-size: 11px;
						border: 1px solid #d2d6e0;
						line-height: 26px;
						padding: 0 8px;
					}

					&>*:not(:last-child){
						margin-right: 5px;
					}

					&>div:nth-child(2) a{
						color: $color__green--primary;
					}
				}

				.giveaway__links{
					height: 25px;
    				display: flex;
					align-items: center;

					a{
						margin-right: 15px;
					}
				}
			}
		}
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: flex;
				justify-content: space-between;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;
				margin-right: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
					margin-right: 5px;
					margin-top: -1px;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.avatar_icon {
		@at-root #{&}__icon {
			font-size: 0.7rem;
			margin-right: 0.25rem;
			color: rgba(0, 0, 0, 0.87);
		}

		@at-root #{&}__header {
			display: flex;
			align-items: center;
		}

		@at-root #{&}__icon {
			height: 3rem;
			width: 3rem;
			line-height: 3rem;
			cursor: pointer;
			@include text($font--role-emphasis, 2rem);
			text-align: center;
			border-radius: 5px;
			background-color: $color__gray--darkest;
			color: #fff;

			@at-root #{&}--small {
				height: 2.5rem;
				width: 2.5rem;
				font-size: 1.75rem;
				line-height: 2.5rem;
			}
			@at-root #{&}--tiny {
				height: 1.5rem;
				width: 1.5rem;
				font-size: 1rem;
				line-height: 1.5rem;
			}
		}
		@at-root #{&}__header_info {
			display: flex;
			flex-direction: column;
			height: 2.5rem;
			color: #000;
		}
		@at-root #{&}__username {
			cursor: pointer;
		}
		@at-root #{&}__date {
			color: $color__darkgray--primary;
			font-size: 0.9rem;
		}
		@at-root #{&}__description {
			margin-top: 0.25rem;
			font-size: 0.9rem;
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.hero_section{
			display: block;
			text-align: center;

			.featured__table{
				display: block;
			}

			.featured__table__column{
				&:not(:first-child) {
					margin-left: 0;
				}
			}
		}
		.giveaway__row-outer-wrap {
			overflow-x: auto;

			.giveaway__row-inner-wrap{
				min-width: 600px;
			}
		}
	}
	.idc-brand {
		background-image: url("https://cdn.idcgames.net/img/default/logo-idc-dark.png");
		/* background-image: url("https://cdn.idcgames.net/img/default/logo-idc-light.png"); */
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;    
	}
	.idc-brand:active,  .idc-brand:hover, .idc-brand:focus{
		background-image: url("https://cdn.idcgames.net/img/default/logo-idc-light.png");
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;    
	}
	.votes{
		height: 40px;
		width: 95%!important;
		cursor: pointer;
	}	
</style>
